import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AUTH_CALLBACK_PATH, hasAuthCallbackPayload } from '../utils/auth';

export default function AuthCallbackInterceptor() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === AUTH_CALLBACK_PATH) return;

    const currentUrl = new URL(window.location.href);
    if (!hasAuthCallbackPayload(currentUrl)) return;

    navigate({
      pathname: AUTH_CALLBACK_PATH,
      search: location.search,
      hash: location.hash,
    }, { replace: true });
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
}
